<template>
  <div class="group-rule">
    <div class="nav">
      <span class="sp1"></span>
      <p>拼团规则说明</p>
      <span class="sp2"></span>
    </div>
    <div class="content">
      <p class="title">Q：什么是多人拼团？</p>
      <p class="article">A：多人拼团（以下简称“拼团”）是指由多人一起拼单购买的团购活动，通过拼团买家可以享受比一般网购更低的折扣</p>
      <p class="title">Q：什么是团长？怎样成为团长？</p>
      <p class="article">A：团长即该团的发起人，开团且第一个支付成功即可成为团长</p>
      <p class="title">Q：什么是团员？怎样成为团员？</p>
      <p class="article">A：团员即参与该团的人员，通过团长分享链接进入，且参与支付购买即可成为团员</p>
      <p class="title">Q：怎样算拼团成功？</p>
      <p class="article">A：在拼团有效期内，通过第三方分享平台邀请更多的好友参与拼团，达到成团人数，即可算拼团成功</p>
      <p class="title">Q：拼团失败，如何退款？</p>
      <p class="article">A：如在拼团有效期内未凑齐人数，即算拼团失败，系统会自动将所支付的款项原路退还，具体到账时间以各付渠道为准</p>
      <p class="title">Q：拼团过程中，是否可以申请退款？</p>
      <p class="article">A：在拼团过程中，不支持申请退款，成团后如有售后问题可申请退款</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupRule",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.group-rule {
  .nav {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    .sp1 {
      width: 160px;
      height: 2px;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 1) 100%
      );
      border-radius: 1px;
      opacity: 0.49;
    }
    p {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(140, 140, 140, 1);
      margin: 0 14px;
    }
    .sp2 {
      width: 160px;
      height: 2px;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      border-radius: 1px;
      opacity: 0.49;
    }
  }
  .content {
    padding: 0 30px;
    .title {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(38, 38, 38, 1);
      line-height: 40px;
      padding-bottom: 10px;
    }
    .article {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(91, 96, 102, 1);
      line-height: 42px;
      padding-bottom: 50px;
    }
  }
}
</style>
